/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Widget Inquiries Empty Component
 *
 * @author Fedorov Maxim
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.1
 */

import { icons } from '../../../../../../assets';
import { LinkBlock } from '../../../../../../components/common';
import {
    FlexColumnStyled,
    FlexMiddleStyled,
} from '../../../../../../components/common/Block/Flexbox';
import { ImgStyled } from '../../../../../../components/common/Block/Img';
import { LayoutStyled } from '../../../../../../components/common/Block/Layout';
import ICommonTranslation from '../../../../../../modules/internationalization/types/common';
import IPageDashboardTranslation from '../../../../../../modules/internationalization/types/pages/dashboard/dashboard';
import { WidgetHelpTitleStyled } from '../../styled/WidgetHelpStyled';
import {
    WidgetOrderInquiriesEmptyContainer,
    WidgetOrderInquiriesEmptyLabelTipsStyled,
} from '../styled/widgetOrderInquiriesStyled';

export interface IWidgetInquiriesEmpty {
    isAllowToCreateInquiry: boolean;
    openCreateInquiry: () => void;
    translation: IPageDashboardTranslation & ICommonTranslation;
}

const WidgetInquiriesEmpty = (props: IWidgetInquiriesEmpty) => {
    return (
        <FlexColumnStyled>
            <FlexMiddleStyled>
                <WidgetOrderInquiriesEmptyContainer>
                    <ImgStyled
                        className="medium"
                        src={icons.transactionMediumIcon}
                    />
                </WidgetOrderInquiriesEmptyContainer>
            </FlexMiddleStyled>
            <LayoutStyled className="mb-1 mt-4 mx-auto t-center" width='270px'>
                <WidgetHelpTitleStyled>
                    {props.translation.widgets.orderInquiries.inquiries.empty.title}
                </WidgetHelpTitleStyled>
            </LayoutStyled>
            <WidgetOrderInquiriesEmptyLabelTipsStyled>
                {props.translation.widgets.orderInquiries.inquiries.empty.helpText}
            </WidgetOrderInquiriesEmptyLabelTipsStyled>

            {
                props.isAllowToCreateInquiry &&
                <div style={{ textAlign: 'center' }}>
                    <LinkBlock
                        dataName="openCreateInquiryModal"
                        onClick={props.openCreateInquiry}
                        onWheelClick={props.openCreateInquiry}
                    >
                        {props.translation.widgets.orderInquiries.inquiries.empty.btnText}
                    </LinkBlock>
                </div>
            }
        </FlexColumnStyled>
    );
};

export default WidgetInquiriesEmpty;
